import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';

export interface BaseRestrictionsEnableProps {
  name: string;
  id: string;
  label: string;
}

export function BaseRestrictionsEnableControl({
  name,
  id,
  label,
}: BaseRestrictionsEnableProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookCheckboxWrapper
      control={control}
      id={id}
      name={name}
      label={label}
    />
  );
}
